import { useMemo, type CSSProperties } from 'react';

export type MessagePosition = {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
};

type MessageConfig = MessagePosition & {
  action?: () => void;
  actionDismiss?: () => void;
};

export const Message = ({
  action,
  top,
  left,
  right,
  bottom,
  actionDismiss,
}: MessageConfig) => {
  const hasTop = top !== undefined;
  const hasBottom = bottom !== undefined;
  const hasLeft = left !== undefined;
  const hasRight = right !== undefined;

  const position = useMemo<CSSProperties>(() => {
    if (hasTop) {
      if (hasLeft) {
        return { left: `${left - 7}px`, top: `${top}px` };
      }
      if (hasRight) {
        return { right: `${right - 7}px`, top: `${top}px` };
      }
      return {};
    }
    if (hasLeft) {
      return {
        left: `${left - 7}px`,
        bottom: `${bottom}px`,
        alignItems: 'flex-end' as const,
      };
    }
    if (!hasRight) return {};
    return {
      right: `${right - 7}px`,
      bottom: `${bottom}px`,
      alignItems: 'flex-end' as const,
    };
  }, [hasLeft, hasRight, hasTop, bottom, left, right, top]);

  return (
    <div
      className="message-container"
      onClick={(e) => e.stopPropagation()}
      style={position}
    >
      {(hasTop || hasBottom) && hasLeft && (
        <>
          <div className="dot" />
          <div className="line" />
        </>
      )}
      <div className="box" data-testid="deposit-while-you-play-tooltip">
        <div className="top">
          <div className="badge" />
          <div
            className="close"
            onClick={actionDismiss}
            data-testid="deposit-while-you-play-tooltip-close-button"
          />
        </div>
        <div className="information">
          <div className="title">Deposit while you play</div>
          <div className="caption">Add funds using your dashboard</div>
        </div>
        <div className="button" onClick={action} />
      </div>
      {(hasTop || hasBottom) && hasRight && (
        <>
          <div className="line" />
          <div className="dot" />
        </>
      )}
    </div>
  );
};
